
import React, { useState, useRef  } from 'react';
import { useSelector} from 'react-redux'
import './carddaydisplay.css'
import './weekprint.css'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { exportComponentAsJPEG, exportComponentAsPDF, exportComponentAsPNG } from 'react-component-export-image';
import 'rc-slider/assets/index.css';
import Aer1 from '../../assets/img/aer1.png'
import Tempo from '../../assets/img/tempo.png'
import Aer2 from '../../assets/img/aer2.png'

import Swim from '../../assets/img/swim.png'
import Base from '../../assets/img/base.png'
import Interval from '../../assets/img/intervalcon.png'
import Ride from '../../assets/img/ride.png'
import Logo from '../../assets/img/logo2.png'
import Yoga from '../../assets/img/yoga.png'
import Race from '../../assets/img/race.png'
import Workout from '../../assets/img/workout.png'
import Walk from '../../assets/img/walk.png'
import None from '../../assets/img/none.png'

import { Doughnut } from "react-chartjs-2";
import {dataDonut} from '../../variables/chartsData'


const ComponentToPrint = React.forwardRef((props, ref) => (
  
    <div class="form-group" style={{backgroundColor:'rgb(40,40,40)'}} ref={ref}>
      <div className="cardDisplay">
        <h2 className="name text-white"></h2>
        <div className='logo'>
          <img style={{cursor:'pointer',width:'30%'}} src={Logo} alt="click" ></img>
        </div>
        <div className='title'>Starting from : {moment().startOf('week').toString().substring(0,16)}</div>
        
        

        
  
  
        <div className="actions">
        <Doughnut data={dataDonut(props.labels,props.dataset)}/>
    <div class="float-container">
        {props.labels.map(activity =><div class="float-child">
            <div class="green"><img style={{cursor:'pointer',height:'45px',width:'45px'}} src={props.subTypeImage(activity)} alt="click" ></img></div>
        </div> )}
    </div>
    
  <div className="follow-info">

  
    <h2 style={{fontSize:'20px'}}><a href="#"><span className="text-success">{props.totalDuration.toFixed(2)}</span><small>Duration</small></a></h2>
    
    <h2 style={{fontSize:'20px'}}><a href="#"><span className="text-warning">{props.totalDistance.toFixed(2)}</span><small>Total Estimated Distance (km)</small></a></h2>
    <h2 style={{fontSize:'20px'}}><a href="#"><span className="text-danger">{props.totalstressScore.toFixed(2)}</span><small>Total Stress Score</small></a></h2>
      
      

    
  </div>
  <div className="follow-info">
    

      
  <h2 style={{fontSize:'20px'}}><a href="#"><span className="text-white">{props.activitiesWeek.length}</span><small>Total Activities</small></a></h2>
  <h2 style={{fontSize:'20px'}}><a href="#"><span className="text-white">{props.totalElv}</span><small>Total Elevation gain (m)</small></a></h2>

    

  </div>
    
  </div>
  
  <div className="desc"></div>
</div>




</div>
));
var moment = require('moment')
const WeekPrintModal = (props) => {
  const {
    buttonLabel,
    className
  } = props;


  //const dispatch = useDispatch()

  

  //console.log(state)
  const [modal, setModal] = useState(false);
  const componentRef = useRef();

 
  const toggle = () => setModal(!modal);
  const subTypeImage = (subType) =>{
    if (subType === "Aerobic I"){
      return Aer1
    }
    if (subType === "Aerobic II"){
      return Aer2
    }
    if (subType === "Base"){
      return Base
    }
    if (subType === "Interval"){
      return Interval
    }
    if (subType === "Threshold"){
      return Tempo
    }
    if (subType === "Ride"){
      return Ride
    }
    if (subType === "Swim"){
      return Swim
    }
    if (subType === "Run"){
      return Tempo
    }
    if (subType === "Race"){
      return Race
    }
    if (subType === "Yoga"){
      return Yoga
    }
    if (subType === "Workout"){
      return Workout
    }
    if (subType === "WeightTraining"){
      return Workout
    }
    if (subType === "Walk"){
      return Walk
    }
    else{
      return None
    }
    
  }  
  var totalDuration = 0
  var totalDistance = 0
  var totalstressScore = 0
  var totalElv = 0
  const today = moment()
  const from_date = today.startOf('isoWeek');
  const to_date = today.endOf('week');
  const activitiesWeek = props?.activities.filter(activity => moment(activity.date).isSame(today, 'week'))
  console.log(activitiesWeek)

  for(var i=0;i<activitiesWeek.length;i++){
      if(activitiesWeek[i].distance){
        totalDistance = totalDistance + activitiesWeek[i].distance
      }
      if(activitiesWeek[i].duration){
        totalDuration = totalDuration + activitiesWeek[i].duration
      }
      if(activitiesWeek[i].stressScore){
        totalstressScore = totalstressScore + activitiesWeek[i].stressScore
      }
      if(activitiesWeek[i].ascent){
        totalElv = totalElv + activitiesWeek[i].ascent
      }
  }
  totalDistance = totalDistance/1000
  var labels = []
  var dataset = []
  for (var i=0;i<activitiesWeek.length;i++){
    if(labels.includes(activitiesWeek[i].sub_type)){
      dataset[labels.indexOf(activitiesWeek[i].sub_type)] = dataset[labels.indexOf(activitiesWeek[i].sub_type)] +1
    }
    else{
      labels.push(activitiesWeek[i].sub_type)
      dataset.push(1)
    }

  }
  console.log(labels,dataset)

  return (
    <React.Fragment>
      <Button onClick={toggle}>Report</Button>

      <Modal isOpen={modal} toggle={toggle} className={className} style={{backgroundColor:'rgb(40,40,40)'}}>
        <ModalHeader toggle={toggle} style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>Week summary</ModalHeader>
        <ModalBody style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
        <ComponentToPrint dataset={dataset} labels={labels} totalElv={totalElv} activitiesWeek={activitiesWeek} subTypeImage={subTypeImage} totalstressScore={totalstressScore} totalDistance={totalDistance} totalDuration={totalDuration}  ref={componentRef} />
          
        </ModalBody>
        <ModalFooter style={{backgroundColor:'rgb(40,40,40)',color:'rgb(48, 189, 255)'}}>
          <Button onClick={() => exportComponentAsJPEG(componentRef)}>
            Export As JPEG
          </Button>
          <Button color="danger" onClick={toggle}>Cancel</Button>
        </ModalFooter>
      </Modal>
      </React.Fragment>
  );
}

export default WeekPrintModal;